import moment from 'moment-timezone';
import DatePicker from 'vue2-datepicker'
import codes from '@/f1/codes';
import { api } from '@/f1/service';
import custom from '@/f1/custom';
import { Switch as cSwitch } from '@coreui/vue';
import Language from './language';

const _i18n_data = {
  otpToken_1: {
    EN : () => `Plz, Typing email.`,
    KO : () => `이메일을 입력하세요..`,
  },
  otpToken_2: {
    EN : () => `typing was not email format`,
    KO : () => `이메일 형식에 맞춰 입력해주세요..`,
  },
}
export default {
  components : { DatePicker, cSwitch, Language },
  data: () => {
    return {
      custom,
      codes,
      so : Object.assign({}, codes.DEFAULT_OPT, { opt : {} }),
      search : { target: 'pattern', cmd : 'list', body: { and: [{name : 'is_del', value: false, op : '='}], or: [], sort: [{ name: 'id', op : 'desc'}] } },
      loading : false
    }
  },
  computed: {
    i18n_data() { return _i18n_data; },
    type() { return this.so.opt.type; },
    level() { return this.so.opt.level; },
    fields_ko : function() {return [
        { key: 'id', label: 'No.', sortable: false, thStyle: 'width: 10%' },
        { key: 'is_alive', label: '사용여부', sortable: true, thStyle: 'width: 10%' },
        { key: 'level', label: '레벨', sortable: false },
        { key: 'type', label: '타입', sortable: false },
        { key: 'code', label: '코드', sortable: false },
        { key: 'created_at', label: '등록일', sortable: true },
        // { key: 'func', label: '더 보기', sortable: false, thStyle: 'width: 10%'  },
      ]
    },
    fields : function() {return [
      { key: 'id', label: 'No.', sortable: false, thStyle: 'width: 10%' },
      { key: 'is_alive', label: 'Usage Status', sortable: true, thStyle: 'width: 10%' },
      { key: 'level', label: 'Level', sortable: false },
      { key: 'type', label: 'Type', sortable: false },
      { key: 'code', label: 'Code', sortable: false },
      { key: 'created_at', label: 'Registed At', sortable: true },
      // { key: 'func', label: 'More', sortable: false, thStyle: 'width: 10%'  },
    ]
  },
    startRow : function() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; },
    rowCount: function() { return this.so.totalRows || 0; }
  },
  watch: {},
  methods: {
    set_sd(v, k = 'created_at') {
      let opt = this.so.opt;
      if(!v) { opt[`${k}_sd`] = undefined; opt[`${k}_ed`] = undefined; }
      else {
        let ed = opt[`${k}_ed`] || moment().startOf('d');
        let sd = opt[`${k}_sd`] || ed;
        switch(v) {
          case '-1d' : sd = moment(sd).subtract(1, 'd'); break;
          case '-1w' : sd = moment(sd).subtract(1, 'w'); break;
          case '-1m' : sd = moment(sd).subtract(1, 'M'); break;
          case 'w' : sd = moment(ed).startOf('isoweek'); break;
          case 'm' : sd = moment(ed).startOf('month'); break;
        }
        opt[`${k}_sd`] = sd.format('YYYY-MM-DD');
      }
      this.so.opt = Object.assign({}, this.so.opt);
    },
    set_op(k, v) {
      if(k.endsWith('_count')) {
        return { name : k, value : 0, op :  v == true ? '>' : '<=' }
      } else if(k.endsWith('_id')) {
        return { name : k, value : Number(v), op :  '=' }
      } else if(k.startsWith('is_')) {
        return { name : k, value : v == false ? false : true, op :  '=' }
      }
      return { name : k, value : `%${v}%`, op : 'like' }
    },
    search_opt() {
      this.so.adv = !this.so.adv;
      if(this.so.adv) {
        this.so.opt['created_at_ed'] = moment().add(1, "day");
        this.so.opt['match_type'] = 'and';
        this.so.sv = ''
      } else { this.reset(); }
    },
    reset() { this.so = Object.assign({}, codes.DEFAULT_OPT, { opt : {} }); this.refresh(); },
    refresh() {
      if(this.loading) { return }
      this.$refs._list ? this.$refs._list.refresh() : '';
    },
    getItems: function(ctx) { return this.load(ctx); },
    load(ctx = {}) {
      if(this.loading) {
        return this.loading = false
      }
      this.loading = true
        let so = {
          target : 'pattern', cmd : 'list',
          body : {
            sort : [{ name : "id", op : "desc" }],
            or : [],
            and : []
          },
          offset : (this.so.currentPage -1 || 0) * Number(this.so.perPage), limit: Number(this.so.perPage), // 10 은 나중에 변수 처리해야함.
        }

        if(['created_at'].indexOf(ctx.sortBy) > -1) { so.body.sort = [ { name : ctx.sortBy, op : !ctx.sortDesc && 'desc' } ]; }
        if(this.$route.params && this.$route.params.site_id) { so.body.and.push(this.set_op('site_id', this.$route.params.site_id, so)); }

        if(this.so.adv && this.so.opt) {
          var k = Object.keys(this.so.opt)
          for (let i = 0; i < k.length; i++) {
            if(k[i] == 'match_type') { continue; }
            let cond = undefined;
            let preprocessing = false

            switch (k[i]) {
              case 'created_at_sd':
                if(!this.so.opt[k[i]]) { this.$toastr.w("start Time is require", "notice"); break; }
                cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : ">=" }
                break;
              case 'created_at_ed':
                if(!this.so.opt[k[i]]) { this.$toastr.w("end Time is require", "notice"); break; }
                cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : "<" }
                break;
              case 'type':
                preprocessing = true
                this.so.opt[k[i]].forEach(r => {
                  so.body.or.push({ name : k[i], value : r, op : "=" })
                });
                break;
              case 'level':
                preprocessing = true
                this.so.opt[k[i]].forEach(r => {
                  so.body.or.push({ name : k[i], value : r, op : "=" })
                });
                break;
              default:
                cond = this.set_op(k[i], this.so.opt[k[i]]);
                break;
            }
            if(!preprocessing) {
              if(cond.value == '%%' || cond.value === '') { continue; }
              if(this.so.opt['match_type'] == "and") { so.body.and.push(cond) }
              else { so.body.or.push(cond) }
            }
          }
        } else {
          if(this.so.sk && this.so.sv != undefined) { so.body.and.push(this.set_op(this.so.sk, this.so.sv, so)); }
        }
      return api.wmds.WMDS(so).then(rs => { this.so.totalRows = rs.total; this.$emit('loading', false); this.loading = false; return rs.body ? rs.body : []; })
        .catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText))
    },
    // async load(ctx = {}) {
    //   let so = {
    //     ok : ctx.sortBy,
    //     od : ctx.sortDesc ? 'd' : 'a',
    //     pg : ctx.currentPage || this.so.currentPage || 1,
    //     pc : ctx.perPage || this.so.perPage || 10,
    //     sk : this.so.sk,
    //     sv : this.so.sv,
    //     opt: this.so.adv ? Object.assign({}, this.so.opt) : {}
    //   }
    //   this.search.limit = so.pc;
    //   this.search.offset = (so.pg - 1) * so.pc
    //   this.search.body.and = [{name : 'is_del', value: false, op : '='}]
    //   if(ctx.sortBy) { this.search.body.sort = [ { name : ctx.sortBy, op : ctx.sortDesc && 'desc' } ]; }
    //   if(so.ok) { this.search.body.sort.push({name: so.ok, op: so.od == 'd' && 'desc' ? 'asc' : 'desc' }); }
    //   // search
    //   if((this.so.sv || '').trim()) { this.search.body.and.push({ name : 'code', value : `%${this.so.sv}%`, op : 'like' }) }
    //   if(so.sk && so.sv) {
    //     const value = so.sv.replace(/\*/g, '%');
    //     for(let key of so.sk.split(',')) {
    //       this.search.body.and.push({"name": key, "value": `%${value}%`, "op": 'like' });
    //     }
    //   }
    //   // search (adv)
    //   for (let [key, value] of Object.entries(so.opt)) {
    //     switch(key) {
    //       case 'is_alive' : this.search.body.and.push({name: 'is_alive', value: value, op: '=' }); break;
    //       case 'created_at_sd' : this.search.body.and.push({name: 'created_at', value: moment(value).valueOf(), op: '>=' }); break;
    //       case 'created_at_ed' : this.search.body.and.push({name: 'created_at', value: moment(value).add(1, 'd').valueOf(), op: '<=' }); break;
    //       // default: search.body.and.push({name: key, value: value.replace(/\*/g, '%'), op: /[%\*]/.test(value) ? 'like' : '=' }); break;
    //     }
    //   }
    //   try { let rs = await api.wmds.WMDS(this.search); this.so.totalRows = rs.total; return rs.body; }
    //   catch(e) { this.$toastr.e(e.data || e); }
    // },
    detail: function(item) { this.$router.push(`/wmds/pattern/${item.id}`); },
  },
  created: function() {   console.log('wmds.pattern.vue', 'created'); },
  destroyed: function() { console.log('wmds.pattern.vue', 'destroyed'); },
  mounted: function() { console.log('wmds.pattern.vue', 'mounted'); },
}
